import React, { useEffect, useState } from "react";
import Request from "../../common/request/request";
import { Container, Row, Col, Image, Nav, Tab, Card, Dropdown, Modal, Button, Form, ListGroup, Navbar} from "react-bootstrap";
import defaultPhoto from "../../images/default.png";
import { NavLink, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ApiV2 from "../../common/apiV2"
import PropTypes from "prop-types";
import _ from "lodash";


function ListShares(props) {
    const [sharedSharelists, setSharedSharelists] = useState([]);

    const handleResponse = async (shareResponse, id) => {
        const responseData = {
            "id": id,
            "isApproved": shareResponse
        }

        var responseMessage = "";
        shareResponse === "true" ? responseMessage = "saved" : responseMessage = "denied";

        try {
            const apiResponse = await ApiV2.saveSharedSharelist(responseData);
            if (apiResponse.status === 200) {
                props.notifyInfo(`Successfully ${responseMessage} collection!`);
                setSharedSharelists(sharedSharelists.filter(sharelist => sharelist.sharelistId != id));
            }
            else {
                props.notifyFailure(`Failed to ${responseMessage} collection.`);
            }
        }
        catch (e) {
            console.log(e);
            props.notifyFailure("Failed to save collection.");
        }
    }

    const handleDelete = (itemToRemove) => {
        console.log(itemToRemove);
        var newSharedSharelists = sharedSharelists.filter(sharelist => sharelist.sharelistId != itemToRemove);
        // setSharedSharelists(newSharedSharelists);
        // console.log(newSharedSharelists);
        console.log(newSharedSharelists);
        setSharedSharelists(newSharedSharelists);
        // console.log(sharedSharelists);
    }

    useEffect(() => {
        const fetchSharedSharelists = async () => {
        try {
            const sharedSharelistsResponse = await ApiV2.getUserSharedSharelists();
            setSharedSharelists(sharedSharelistsResponse.data);
        } catch (error) {
            console.log("unable to fetch sharedSharelists. Error: ", JSON.stringify(error));
        }
    }
    fetchSharedSharelists();
    }
        , []
    );

    const renderSharedSharelists = () => {
        const sharelistCards = sharedSharelists?.filter(sharelist => sharelist.status === "PENDING")?.map((pendingSharelist) => {
            return(
                <Request
                    key = { pendingSharelist.sharelistId }
                    request = { pendingSharelist }
                    notifyInfo= { props.notifyInfo }
                    notifyFailure= { props.notifyFailure }
                    handleResponse = { handleResponse }
                    handleDelete = { handleDelete }
                />
            );
        });
        return sharelistCards;
    }

    return (
        <Container className="px-2">
            <Navbar expand="lg" variant="light" sticky="top" fixed="top" className="top-nav nav-fill">
                <Nav>
                    <Nav.Link>
                        <Button onClick={() => props.history.push("/profile")}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </Button>
                    </Nav.Link>
                </Nav>
                <Navbar.Brand className="brand">{"Collection Requests"}</Navbar.Brand>
            </Navbar>
            {renderSharedSharelists()}
        </Container>
    );
}
  
ListShares.propTypes = {
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired

};

export default withRouter(ListShares);